export const initials = (name = '') => {
  const words = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '?';
  const first = Array.from(words[0]);
  return (words.length > 1 ? first[0] + Array.from(words[words.length - 1])[0] : first.slice(0, 2).join('')).toLocaleUpperCase();
};
export const filterConversations = (chats, filter, unreadByChat) => (chats || []).filter((chat) => {
  const unread = Number(unreadByChat?.get(String(chat.id)) || 0) > 0;
  return filter === 'all' || (filter === 'unread' ? unread : !unread);
});
